module.exports = __webpack_public_path__ + "img/img_6.74182ef8.png";